import { Decimal } from 'decimal.js';
import { getDecimalFloor } from '.';
import { isNil } from '@alk/core';
const identity = (val) => val;
const localDefault = navigator.language;
const multiplierMap = {
    k: (num) => Number(num * 1e3).toString(),
    m: (num) => Number(num * 1e6).toString(),
    b: (num) => Number(num * 1e9).toString(),
};
export function convertAmountShorcut(value) {
    if (!value) {
        return '';
    }
    const pattern = /^(-?\d+(.\d+)?)([mkb]?)$/gi;
    if (value.match(pattern)) {
        const [, num, , multiplier] = pattern.exec(value);
        return (multiplierMap[multiplier.toLowerCase()] || identity)(num);
    }
    return value;
}
export const formatNumberByLocale = (locale) => (value) => new Intl.NumberFormat(locale).format(value);
export const formatNumber = formatNumberByLocale(localDefault);
// to test Intl with other locales than 'en-US' you have to install the full icu node support
// https://nodejs.org/api/intl.html#intl_options_for_building_node_js
export const formatAmountByLocale = (locale) => (maximumFractionDigits = 2) => (minimumFractionDigits = 2) => (value) => new Intl.NumberFormat(locale, { maximumFractionDigits, minimumFractionDigits }).format(value);
// to test Intl with other locales than 'en-US' you have to install the full icu node support
// https://nodejs.org/api/intl.html#intl_options_for_building_node_js
export const formatPointsByLocale = (locale) => (fractionDigits = 2) => (value) => {
    const valueFloor = getDecimalFloor(value, fractionDigits);
    return new Intl.NumberFormat(locale, {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        useGrouping: false,
    }).format(valueFloor);
};
export const formatAmount = formatAmountByLocale(localDefault)()();
export function getThousandSeparator(locale) {
    var _a;
    const formatParts = Intl.NumberFormat(locale).formatToParts(1000);
    const symbol = formatParts.find((part) => part.type === 'group');
    return (_a = symbol === null || symbol === void 0 ? void 0 : symbol.value) !== null && _a !== void 0 ? _a : ',';
}
export function getDecimalSymbol(locale) {
    var _a;
    const formatParts = Intl.NumberFormat(locale).formatToParts(1.23);
    const symbol = formatParts.find((part) => part.type === 'decimal');
    return (_a = symbol === null || symbol === void 0 ? void 0 : symbol.value) !== null && _a !== void 0 ? _a : '.';
}
/**
 * toFixed without rounding
 */
export const toFixed = (fixed = -1) => (num) => {
    const xNb = num.toString().split('.');
    if (fixed <= 0) {
        return xNb[0];
    }
    const yNb = xNb[1] || '';
    return yNb.length > fixed ?
        `${xNb[0]}.${yNb.substr(0, fixed)}` :
        `${xNb[0]}.${yNb.padEnd(fixed, '0')}`;
};
/**
 * return value with exact precision
 * @param firstNumber
 * @param secondNumber
 */
export const multiplyNumberWithExactPrecision = (firstNumber, secondNumber) => {
    if (isNil(firstNumber) || isNil(secondNumber)) {
        return NaN;
    }
    const decimalValue = new Decimal(firstNumber);
    return Number(decimalValue.times(secondNumber));
};
/**
 * return value with exact precision
 * @param firstNumber
 * @param secondNumber
 */
export const subtractNumberWithExactPrecision = (firstNumber, secondNumber) => {
    if (isNil(firstNumber) || isNil(secondNumber)) {
        return NaN;
    }
    const decimalValue = new Decimal(firstNumber);
    return Number(decimalValue.minus(secondNumber));
};
/**
 * return value with exact precision
 * @param firstNumber
 * @param secondNumber
 */
export const addNumberWithExactPrecision = (firstNumber, secondNumber) => {
    if (isNil(firstNumber) || isNil(secondNumber)) {
        return NaN;
    }
    const decimalValue = new Decimal(firstNumber);
    return Number(decimalValue.add(secondNumber));
};
